// Localize a stored asset region string (mostly English transliteration in the DB,
// one Ukrainian) to the selected UI language. Keyword-matched so it tolerates the
// stored variants ("Odessa oblast", "Одеська обл., Україна", "Dnipro oblast", …).
export function localizeRegion(region: string | null | undefined, lang: string): string {
  if (!region) return '';
  const r = region.toLowerCase();
  const uk = String(lang).toUpperCase() === 'UA' || String(lang).toLowerCase() === 'uk';
  const m: { test: RegExp; uk: string; en: string }[] = [
    { test: /(odes|одес)/,            uk: 'Одеська область',          en: 'Odesa oblast' },
    { test: /(zakarpat|закарпат)/,    uk: 'Закарпатська область',     en: 'Zakarpattia oblast' },
    { test: /(dnipro|дніпро|днепр)/,  uk: 'Дніпропетровська область', en: 'Dnipropetrovsk oblast' },
    { test: /(mykolaiv|микол|никол)/, uk: 'Миколаївська область',     en: 'Mykolaiv oblast' },
    { test: /(kherson|херсон)/,       uk: 'Херсонська область',       en: 'Kherson oblast' },
    { test: /(zaporizh|запор)/,       uk: 'Запорізька область',       en: 'Zaporizhzhia oblast' },
    { test: /(kyiv|kiev|київ|киев)/,  uk: 'Київська область',         en: 'Kyiv oblast' },
  ];
  for (const e of m) if (e.test.test(r)) return uk ? e.uk : e.en;
  return region;
}
